import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-4" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-2" }
const _hoisted_3 = { class: "text-base sm:text-lg font-bold text-brown flex items-center gap-2" }
const _hoisted_4 = { class: "text-xs text-alternative-gray" }
const _hoisted_5 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3" }


import { MonthDayReport } from "@/types/calculators";
import TopDayCard from "@/views/Calculators/PersonalDates/components/monthReport/TopDayCard.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'TopDaysComponent',
  props: {
    topDays: {}
  },
  emits: ["selectDay"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-gold" }, "★", -1)),
          _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.top-days.title")), 1)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("calculators.personal-date.top-days.desc")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.topDays, (dayReport, index) => {
        return (_openBlock(), _createBlock(TopDayCard, {
          key: dayReport.date,
          dayReport: dayReport,
          dayIndex: index,
          onClick: ($event: any) => (emit('selectDay', dayReport))
        }, null, 8, ["dayReport", "dayIndex", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})